const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/subdepartments`,
    information: `${API_URL}/subdepartment/information`
};

export default apiUrls;
